import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { MenuProps } from "@mui/material/Menu";
import {
  DropDownLabel,
  StyleBox,
  StyleInputLabel,
} from "./BenevvDropDown.styles";

interface BenevvDropDownProps {
  label: string;
  placeholder: string;
  styleDropDown?: object;
  values?: Array<string | number>;
  setTextField: (field: any) => void;
}
export default function BenevvDropDown(props: BenevvDropDownProps) {
  const [screenData, setScreenData] = useState("");
  const {
    label,
    placeholder,
    styleDropDown,
    values = [],
    setTextField,
  } = props;

  const handleChange = (event: any) => {
    setScreenData(event.target.value);
    setTextField(event.target.value);
  };

  return (
    <>
      <DropDownLabel>{label}</DropDownLabel>
      <StyleBox sx={styleDropDown}>
        <FormControl fullWidth variant="outlined">
          <StyleInputLabel
            shrink={!!screenData}
            htmlFor={label}
          >
            {placeholder}
          </StyleInputLabel>
          <Select
            required
            label={placeholder}
            value={screenData}
            onChange={handleChange}
            inputProps={{ id: label }}
            MenuProps={{
              PaperProps: {
                style: {
                  zIndex: 2000,
                  maxHeight: 300,
                },
              },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              disablePortal: false,
            }}
          >
            {values &&
              values.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </StyleBox>
    </>
  );
}
